export const ARRAY_DATA_NOT_EXISTS = -1;
